import { Server } from 'socket.io';

export default function (req, res, next) {
    if (!res.socket.server.io) {
        console.log('Socket.io server starting...');
        const io = new Server(res.socket.server, {
            cors: {
                origin: ["http://localhost:3000"],
                methods: ["GET", "POST"],
                credentials: true
            }
        });

        io.on('connection', (socket) => {
            console.log('a user connected');

            socket.on('message', (data) => {
                console.log(data);
                socket.emit('response', { message: 'Mensagem recebida' });
            });

            socket.on('disconnect', () => {
                console.log('user disconnected');
            });
        });

        res.socket.server.io = io;
    } else {
        console.log('Socket.io server already running...');
    }
    next();
}
